function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M109.422 29.938v79.141l-15.841 8.936-3.957 2.234L74.105 129V49.86l15.52-8.751 3.956-2.234 15.841-8.937z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M74.105 49.86V129l-16.809-9.481-3.97-2.248L37 108.062v-79.14l16.325 9.222 3.971 2.235 16.81 9.48z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M71.951 59.813l-6.975-3.925v-7.82l6.975 3.896v7.849zm-6.506-4.182l6.052 3.408v-6.788l-6.052-3.409v6.789z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M69.226 57.32l-1.524-.873V52.51l1.524.873v3.939z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M70.75 54.972l-4.558-2.564 2.271-1.403 2.286 3.967zM74.105 49.874L37 28.92 72.317 9l37.106 20.938-35.318 19.936z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M89.625 41.123l-37.12-20.952 3.971-2.235 37.105 20.939-3.956 2.248z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M57.297 40.379v79.14l-3.971-2.248V38.145l3.971 2.234z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M57.297 40.378l35.317-19.921-3.971-2.248-35.317 19.935 3.971 2.234z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  d: "M37 28.921l37.105 20.953-19.534-10.47L37 28.922zM109.422 29.938L74.105 49.874l19.534-10.47 15.783-9.466z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M54.233 19.211l.279-.157 18.186 10.254 17.805-10.04.279.144-17.82 10.053 18.655 10.527-.278.157-18.656-10.526-17.219 9.724-.278-.157 17.234-9.724L54.233 19.21z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M93.581 38.874v79.141l-3.957 2.234v-79.14l3.957-2.235z"
});

function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 138,
    fill: "none",
    viewBox: "0 0 145 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.5021ed5a.svg";
export { ForwardRef as ReactComponent };